// src/components/StanceCard.jsx
const STANCE_META = {
  liberal: { emoji: '🟦', tint: 'from-blue-50 to-blue-100' },
  conservative: { emoji: '🟥', tint: 'from-red-50 to-red-100' },
  factual: { emoji: '⚪', tint: 'from-gray-50 to-gray-100' },
};

export default function StanceCard({ stance, label, description, selected, onSelect }) {
  const meta = STANCE_META[stance] ?? STANCE_META.factual;
  return (
    <button
      type="button"
      onClick={() => onSelect(stance)}
      className={`text-left card hover:shadow-md transition w-full bg-gradient-to-br ${
        meta.tint
      } ${selected ? 'ring-primary' : ''}`}
    >
      <div className="text-3xl mb-2">{meta.emoji}</div>
      <div className="font-bold text-lg">{label}</div>
      {description && <p className="text-xs text-gray-600 mt-1">{description}</p>}
    </button>
  );
}
